import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from "@angular/router";
import { Biggen } from "../directives/biggen";
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-tacitus',
  imports: [RouterLink, Biggen, Link],
  templateUrl: './tacitus.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tacitus.scss',
})
export class Tacitus {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Tacitus`);
    this.dynamicTitle.description(`Tacitus' reference is interpolated and does not provide clear historical evidence for the existence of Jesus as a historical figure.`);
  }
}
